import { IBaseReducer } from 'models';

export interface IMapReducer extends IBaseReducer, Partial<ILocation> {
	matchedLocations: ILocation[];
	isLocationSearchForOffice: boolean;
	isLocationChanged?: boolean;
	zoomTypeIndex: MAP_ZOOM_TYPE_INDEXES;
}

export interface ILocation {
	country: string;
	city?: string;
	office?: string;
}

// represents indexes used in zoomMap function in Map component
export enum MAP_ZOOM_TYPE_INDEXES {
	worldZoom = 0,
	countryZoom = 1,
	cityZoom = 2,
	officeZoom = 3,
}

export interface ILocationSearchParams {
	surveyRoundId: string;
	keyword: string;
}
